import React, { useState, useEffect, useContext } from 'react';
import getHubStatus from "app/utils/app-record-management/getHubStatus";
import Notification from 'app/components/atoms/Notification/Notification';
import AppRecordsContext from "app/components/organisms/InteractiveConfigToolWithAppRecords/AppRecordsContext";

const NotificationManager = () => {
  const [notification, setNotification] = useState(null);
  const [isClosed, setIsClosed] = useState(false);

  // Get socket from context
  const { socket } = useContext(AppRecordsContext);

  // Load initial notification on mount
  useEffect(() => {
    const loadInitialNotification = async () => {
      try {
        const hubStatus = await getHubStatus();
        const notificationObj = hubStatus.find(item => item.status === "notification");
        const ndata = notificationObj && notificationObj.value ? JSON.parse(notificationObj.value) : null;

        if (ndata && (ndata.title || ndata.message)) {
          setNotification({ title: ndata.title, message: ndata.message, type: ndata.type });
          setIsClosed(false);
        }
      } catch (error) {
        console.error('Error loading initial notification:', error);
      }
    };

    loadInitialNotification();
  }, []);

  // Listen to route changes via popstate and pushstate
  useEffect(() => {
    const handleRouteChange = () => {
      setIsClosed(false);
    };

    window.addEventListener('popstate', handleRouteChange);

    const originalPushState = history.pushState;
    history.pushState = function (...args) {
      originalPushState.apply(history, args);
      handleRouteChange();
    };

    return () => {
      window.removeEventListener('popstate', handleRouteChange);
      history.pushState = originalPushState;
    };
  }, []);

  // Listen for real-time notifications and missed notifications on reconnect
  useEffect(() => {
    if (!socket) return;

    const handleNotification = (data) => {
      setNotification({ title: data.title, message: data.message, type: data.type });
      setIsClosed(false);
    };

    socket.on('notification', handleNotification);

    socket.on('connect', async () => {
      try {
        const hubStatus = await getHubStatus();
        const notificationObj = hubStatus.find(item => item.status === "notification");
        const ndata = notificationObj && notificationObj.value ? JSON.parse(notificationObj.value) : null;

        if (ndata && (ndata.title || ndata.message)) {
          setNotification({ title: ndata.title, message: ndata.message, type: ndata.type });
          setIsClosed(false);
        }
      } catch (error) {
        console.error('Error fetching notifications on reconnect:', error);
      }
    });

    return () => {
      socket.off('notification', handleNotification);
      socket.off('connect');
    };
  }, [socket]);

  const handleClose = () => {
    setIsClosed(true);
  };

  if (isClosed || !notification) return null;

  return <Notification notification={notification} onClose={handleClose} />;
};

export default NotificationManager